<template>
	<section class='knd-map m-b-md'>

		<div class='knd-map__content'>
			<div class='knd-intro' ref='intro'>
				<p>
					Deze kaart combineert woningcorporatiebezit met energiearmoede. 
				</p>

				<div class='m-b-sm m-t-md legenda-img'>
					<img src='@/assets/legenda.svg' />
				</div>
				<div class='knd-btn knd-btn__default' v-on:click="closeIntro">
					sluiten
				</div>

			</div>


			<div class='knd-gemeente-input knd-input-field m-b-sm m-t-sm'>
				<input id="gemeenteinput" placeholder="Zoek op gemeente" />
			</div>

			<div class='container-map' ref='chart'>

				<div class='reset-map knd-text-sm' v-show="showReset">
					<div v-on:click="onZoomOut">
						zoom uit
					</div>
				</div>
				

				<div class='scroll-overlay' ref='overlay'>
					<div class='scroll-overlay_hint'>
						{{overlayText}}
					</div>
				</div>

				<!-- Tooltip -->
				<div class='knd-tooltip' ref='tooltip' v-if="highlight" 
					v-bind:style="{ 'left': tooltipXpos +'px', 'top': tooltipYpos +'px'}">
						<div class='knd-tooltip__title'>
							<span v-if="highlight.WK_NAAM">{{highlight.WK_NAAM}},</span>
							{{highlight.GM_NAAM}}
						</div>

						<div class='knd-tooltip__info knd-tooltip__energiearmoede'
							v-if="highlight.energiearmoede">
							<span>Energiearmoede:</span>
							{{highlight.energiearmoede}} 
							<span v-if="highlight.energiearmoedeLabel">
								({{highlight.energiearmoedeLabel}})
							</span>
						</div>

						<div 
							class='knd-tooltip__info knd-tooltip__woningcorperatiebezit' 
							v-if="highlight.woningcorporatie_prct">
							<span>Woningcorperatiebezit: </span>
							{{highlight.woningcorporatie_prct}}% 
							<span v-if="highlight.woningcorperatiebezitLabel">
								({{highlight.woningcorperatiebezitLabel}})
							</span>
						</div>

						<div 
							class='knd-tooltip__info' 
							v-if="!highlight.woningcorporatie_prct && !highlight.energiearmoede">
								Wijkgegevens onbekend
						</div>


						<div class='knd-tooltip__info knd_tooltip__zoomin_label ta-center' v-if="!highlight.WK_NAAM">
							klik om per wijk te bekijken
						</div>

					</div>
			</div>

		</div>
		<div class='knd-source knd-text-sm'>
			Bron: Energiearmoede (2019), TNO; woningcorporatiebezit (2019),CBS
		</div>
	</section>
</template>

<script>
	import * as Awesomplete from 'awesomplete';
	import 'awesomplete/awesomplete.css';
	import debounce from './debounce';
	import { select } from 'd3-selection';

	import gemeenteData from '@/assets/geo/wijk_2019_v2up.json';
	import * as topojson from 'topojson';
	
	import MapChart from './map';
	import './kaart.scss';

	const d3 = {
		select
	}

	const vueObject = {
		props: ['data'],
		mounted: function() {
			this.renderChart();
			this.renderAutoComplete();

			let desktop = 'Gebruik shift + scrollen om in en uit te zoomen op de kaart';
			let mobile = 'Gebruik twee vingers om de kaart te verplaatsen';

			this.overlayText = this.isMobile() ? mobile : desktop;

			// this.renderLegendIntro();
		},
		data: function() {
			return {
				highlight: {},
				tooltipXpos: 10,
				tooltipYpos: 300,
				showReset: false,
				overlayText: ''
			}
		},
		methods: {
			isMobile() {
				if (('ontouchstart' in window) ||
						(navigator.maxTouchPoints > 0) ||
						(navigator.msMaxTouchPoints > 0)) {
							/* browser with either Touch Events of Pointer Events
								 running on touch-capable device */
					return true;
				}
				return false;
			},

			closeIntro() {
				this.$refs.intro.classList.add('hide');
			},

			renderAutoComplete() {
				let gemeentes = this.data.objects.gemeente.geometries.map(d => {
					return {label: d.properties.GM_NAAM, value: d.properties.GM_CODE}
				});

				this.inputGemeente = document.getElementById("gemeenteinput");

				new Awesomplete(this.inputGemeente, {
					list: gemeentes,
					replace: (suggestion) => {
						this.inputGemeente.value = suggestion.label;
						this.zoominGemeente(suggestion.value);
					}
				});
			},

			zoominGemeente(gmCode) {
				this.chart.zoomIn(gmCode);

				document.activeElement.blur();
			},	

			resetSearch() {
				this.inputGemeente.value = '';
			},

			onZoomOut() {
				this.chart.resetZoom();
			},

			renderChart() {
				var NLgeo = topojson.feature(this.data, this.data.objects.wijk_2019_v2up);
				var NLGemeente = topojson.feature(this.data, this.data.objects.gemeente);

				this.chart = new MapChart()
					.container(this.$refs.chart)
					.data([NLgeo, NLGemeente])
					.margin({top: 10, right: 30, bottom: 30, left: 30})
					.height(true)
					.width(true)
					.onMouseOver((d, x, y) => this.showTooltip(d, x, y))
					.onMouseOut(d => this.hideTooltip())
					.onResetSearch(() => this.resetSearch())
					.onShowOverlay((bool) => this.showOverlay(bool))
					.onShowReset((bool) => this.showResetBtn(bool))
					.onShowIntro((bool) => this.showIntro(bool))
					.render();

			},

			renderLegendIntro() {
				let legendContent = this.chart.legend('intro');
				const xPosLegend = this.chart.width() < 400 ? 75 : 150;

				this.legend = d3.select('.knd-intro__legend_g')
					.attr('class', `knd-legend` )
					.attr("transform", "translate("+ 100 +"," + 75 + ")")
					.html(legendContent);
			},

			showTooltip(d, xPos, yPos) {
				this.highlight = d;

				this.$refs.tooltip.classList.add('show');

				let padding = 15;
				let tooltipWidth = this.$refs.tooltip ? this.$refs.tooltip.offsetWidth : 0

				this.tooltipYpos = yPos + padding;
				this.tooltipXpos = xPos - (tooltipWidth /2);
			},

			hideTooltip() {
				this.$refs.tooltip.classList.remove('show');
			},

			showResetBtn(bool) {
				this.showReset = bool;
			},

			showIntro(bool) {
				this.$refs.intro.classList.remove('hide');
			},

			showOverlay(bool) {
				var myEfficientFn = debounce(() => {
					this.$refs.overlay.classList.remove('show');
				}, 1500);

				if(bool) {
					this.$refs.overlay.classList.add('show');
					myEfficientFn();

				} else {
					this.$refs.overlay.classList.remove('show');
				}
			}
		}
	}

	export default vueObject;

// AANTAL_HH: 32005
// GM_CODE: "GM0394"
// GM_NAAM: "Haarlemmermeer"
// WK_CODE: "WK039401"
// WK_NAAM: "Hoofddorp"
// energiearmoede: "2,64%"
// energiearmoedeLabel: "laag"
// prct_inw_met_laaginkomen: "34,4"
// woningcorperatiebezitLabel: ""
// woningcorporatie_prct: "26"

</script>

